import React, { Suspense, useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { CSpinner } from "@coreui/react";
import "./scss/style.scss";
import { loginUser, getProfile } from "./redux/actions/profile";
import { LOGIN_USER } from "./redux/constants/actionTypes";

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
const VerifyOTP = React.lazy(() => import("./views/pages/login/VerifyOTP"));
const ForgotPassword = React.lazy(
  () => import("./views/pages/login/ForgotPassword"),
);
const ConfirmResetPassword = React.lazy(() => import("./views/pages/login/ResetPassword.js"));
const Register = React.lazy(() => import("./views/pages/register/Register"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));
const MobilePrintAllSchedules = React.lazy(
  () => import("./Pages/TradingMethod/MobilePrintAllSchedules"),
);
//Apple
const App = () => {
  const isLoggedIn = useSelector((state) => state?.profile?.isLoggedIn);
  const hasToken = !!localStorage?.getItem("token");
  const isAuthenticated = isLoggedIn || hasToken;
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isLoggedIn) {
      const token = localStorage?.getItem("token");
      const userdata = localStorage?.getItem("UserId");
      if (token != null) {
        dispatch({ type: LOGIN_USER, payload: {} });
        dispatch(getProfile());
      }
    }
  }, [isLoggedIn]);
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="pt-3 text-center">
            <CSpinner color="primary" variant="grow" />
          </div>
        }
      >
        <Routes>
          <Route
            exact
            path="/reset-password/:token"
            name="Reset Password Page"
            element={<ConfirmResetPassword/>}
          />
          <Route exact path="/login" name="Login Page" element={<Login />} />
          <Route
            exact
            path="/verify-otp"
            name="Verify OTP Page"
            element={<VerifyOTP />}
          />
          <Route
            exact
            path="/forgot-password"
            name="Forgot Password Page"
            element={<ForgotPassword />}
          />
          <Route
            exact
            path="/register"
            name="Register Page"
            element={<Register />}
          />
          <Route
            exact
            path="/mobile/:assessment_year/:customer_id/print_full_company_schedule"
            element={isAuthenticated ? <MobilePrintAllSchedules /> : <Navigate to="/login" />}
          />
          <Route
            exact
            path="/mobile/:assessment_year/:customer_id/print_full_company_schedule"
            element={isAuthenticated ? <MobilePrintAllSchedules /> : <Navigate to="/login" />}
          />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route
            path="*"
            name="Home"
            element={<DefaultLayout isLoggedIn={isAuthenticated} />}
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

// const ProtectedRoute = ({ component: Component, ...rest }) => {
//   const isLoggedIn = useSelector(state=>state?.profile?.isLoggedIn)
//     return(<Route {...rest} render={props => (
//       isLoggedIn ?
//         <Component {...props} /> :
//         <Redirect to="/login" />
//     )} />
//   );
// };
export default App;
